<template>
    <div name="document" class="document" v-if="document === 1">
        <img class="image" src="../../assets/showcase/xi/detail/common/document/1/1.png" @click="goDetail"/>
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/document/1/2.png" />
            <div class="button1" @click="() => document = 1">
            
            </div>
            <div class="button2" @click="() => document = 2" >
        
            </div>
            <div class="button3" @click="() => document = 3" >
        
            </div>
            <div class="button4" @click="() => document = 4">

            </div>
            <div class="button5" @click="() => document = 5">

            </div>
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/common/document/1/3.png"  style="margin-top: -6px;"/>
    </div>
    <div name="document" class="document" v-else-if="document === 2">
        <img class="image" src="../../assets/showcase/xi/detail/common/document/2/1.png" @click="goDetail"/>
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/document/2/2.png" />
            <div class="button1" @click="() => document = 1">
            
            </div>
            <div class="button2" @click="() => document = 2" >
        
            </div>
            <div class="button3" @click="() => document = 3" >
        
            </div>
            <div class="button4" @click="() => document = 4">

            </div>
            <div class="button5" @click="() => document = 5">

            </div>
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/common/document/2/3.png" style="margin-top: -6px;"/>
    </div>
    <div name="document" class="document" v-else-if="document === 3">
        <img class="image" src="../../assets/showcase/xi/detail/common/document/3/1.png" @click="goDetail"/>
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/document/3/2.png" />
            <div class="button1" @click="() => document = 1">
            
            </div>
            <div class="button2" @click="() => document = 2" >
        
            </div>
            <div class="button3" @click="() => document = 3" >
        
            </div>
            <div class="button4" @click="() => document = 4">

            </div>
            <div class="button5" @click="() => document = 5">

            </div>
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/common/document/3/3.png" style="margin-top: -6px;" />
    </div>
    <div name="document" class="document" v-else-if="document === 4">
        <img class="image" src="../../assets/showcase/xi/detail/common/document/4/1.png" @click="goDetail"/>
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/document/4/2.png" />
            <div class="button1" @click="() => document = 1">
            
            </div>
            <div class="button2" @click="() => document = 2" >
        
            </div>
            <div class="button3" @click="() => document = 3" >
        
            </div>
            <div class="button4" @click="() => document = 4">

            </div>
            <div class="button5" @click="() => document = 5">

            </div>
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/common/document/4/3.png" style="margin-top: -6px;"/>
    </div>
    <div name="document" class="document" v-else-if="document === 5">
        <img class="image" src="../../assets/showcase/xi/detail/common/document/5/1.png" @click="goDetail"/>
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/document/5/2.png" />
            <div class="button1" @click="() => document = 1">
            
            </div>
            <div class="button2" @click="() => document = 2" >
        
            </div>
            <div class="button3" @click="() => document = 3" >
        
            </div>
            <div class="button4" @click="() => document = 4">

            </div>
            <div class="button5" @click="() => document = 5">

            </div>
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/common/document/5/3.png" style="margin-top: -6px;"/>
    </div>

</template>

<script>
export default {
    name: 'document',
    data: function()
    {
        return {
            document: 1
        }
    },
    methods: {
        goDetail: function()
        {
            this.$emit('goDetailTab')
        }
    }
}
</script>

<style scoped>
    .document {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .image {
        width: 100%;
    }
    .wrapper {
        position: relative;
        width: 100%;
    }
    .button1 {
        position: absolute;
        width: 20%;
        aspect-ratio: 2/1.0;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 14%;
        aspect-ratio: 2/1.5;
        top: 0;
        left: 20%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 17%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 34%;
        z-index: 1;
    }
     .button4 {
        position: absolute;
        width: 17%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 51%;
        z-index: 1;
    }
    .button5 {
        position: absolute;
        width: 12%;
        aspect-ratio: 2/1.7;
        top: 0;
        left: 68%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Document.vue